<div class="flex flex-col h-full w-full gap-4">
  <div class="text-sm text-gray-700">
    Review the planned consolidation actions below. Nothing is saved until you click
    <b>Save</b> or <b>Save &amp; Activate</b> on the Program form after this dialog closes.
  </div>

  <!-- Case A: Delete loser (winner already attached) -->
  <div *ngIf="caseA.length > 0" class="flex flex-col gap-2">
    <div class="qb-group-label">
      Delete Loser — Winner Already Attached ({{ caseA.length }})
    </div>
    <div class="text-xs text-gray-600">
      The inactive loser config will be removed from this program. The active winner is already attached.
    </div>
    <div class="border rounded">
      <table class="w-full text-sm">
        <thead class="bg-gray-100">
          <tr>
            <th class="text-left px-2 py-1">Product</th>
            <th class="text-left px-2 py-1">SKU</th>
            <th class="text-left px-2 py-1">Loser (Delete)</th>
            <th class="text-left px-2 py-1">Winner (Keep)</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let a of caseA" class="border-t">
            <td class="px-2 py-1">{{ a.productTypeName }}</td>
            <td class="px-2 py-1">{{ a.productKey }}</td>
            <td class="px-2 py-1 text-red-700">{{ a.loserConfigName }}</td>
            <td class="px-2 py-1 text-green-700">{{ a.winnerConfigName }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Case B: Attach winner then delete loser -->
  <div *ngIf="caseB.length > 0" class="flex flex-col gap-2">
    <div class="qb-group-label">
      Attach Winner + Delete Loser ({{ caseB.length }})
    </div>
    <div class="text-xs text-gray-600">
      The active winner is not yet attached to this program. It will be attached (inheriting
      <b>Force Approval</b> from the loser), then the loser will be removed.
    </div>
    <div class="border rounded">
      <table class="w-full text-sm">
        <thead class="bg-gray-100">
          <tr>
            <th class="text-left px-2 py-1">Product</th>
            <th class="text-left px-2 py-1">SKU</th>
            <th class="text-left px-2 py-1">Loser (Delete)</th>
            <th class="text-left px-2 py-1">Winner (Attach)</th>
            <th class="text-left px-2 py-1">Force Approval?</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let a of caseB" class="border-t">
            <td class="px-2 py-1">{{ a.productTypeName }}</td>
            <td class="px-2 py-1">{{ a.productKey }}</td>
            <td class="px-2 py-1 text-red-700">{{ a.loserConfigName }}</td>
            <td class="px-2 py-1 text-green-700">{{ a.winnerConfigName }}</td>
            <td class="px-2 py-1">{{ a.isForceApproval ? 'Yes' : 'No' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Case C: Cannot resolve -->
  <div *ngIf="caseC.length > 0" class="flex flex-col gap-2">
    <div class="qb-group-label">
      Cannot Resolve — No Unambiguous Winner ({{ caseC.length }})
    </div>
    <div class="text-xs text-gray-600">
      These inactive loser configs have no single active peer under the same Priced Product Type.
      They will be left as-is. Fix the supplier-side priced configurations first (ensure exactly one
      Active peer), then rerun Consolidate Me.
    </div>
    <div class="border rounded">
      <table class="w-full text-sm">
        <thead class="bg-gray-100">
          <tr>
            <th class="text-left px-2 py-1">Product</th>
            <th class="text-left px-2 py-1">SKU</th>
            <th class="text-left px-2 py-1">Loser</th>
            <th class="text-left px-2 py-1">Reason</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let a of caseC" class="border-t">
            <td class="px-2 py-1">{{ a.productTypeName }}</td>
            <td class="px-2 py-1">{{ a.productKey }}</td>
            <td class="px-2 py-1">{{ a.loserConfigName }}</td>
            <td class="px-2 py-1 text-orange-700">{{ a.reasonC }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Empty state -->
  <div *ngIf="actions.length === 0" class="text-center text-gray-500 italic py-8">
    No inactive product configurations were found in this program. Nothing to consolidate.
  </div>

  <!-- Button Bar -->
  <div class="flex pt-2 items-center gap-2 mt-auto">
    <p-button *ngIf="hasActionable" (onClick)="onGoAhead()" label="Go Ahead" icon="pi pi-check"
      severity="danger"></p-button>
    <p-button (onClick)="onCancel()" [label]="hasActionable ? 'Cancel' : 'Close'" icon="pi pi-times"></p-button>
  </div>
</div>
